module.exports = ".container {\n  padding: 200px 20px; }\n"